export function isAndroid(): boolean {
  try {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    return /android/i.test(userAgent);
  } catch (e) {
    return false;
  }
}
